export default "__VITE_ASSET__f41246cc__"